import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { InfoOutlined as InfoIcon } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";

interface EmptyTablePlaceholderProps {
  text: string;
  refresh: () => void;
}

const EmptyTablePlaceholder: React.FC<EmptyTablePlaceholderProps> = ({
  text,
  refresh,
}) => (
  <tr>
    <td>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center" // Bu satırı ekleyin
        py={8}
      >
        <div className="center-x">
          <InfoIcon fontSize="large" color="action" />
          <Typography variant="h6" color="textSecondary">
            {text}
          </Typography>
          {refresh ? (
            <Button variant={"text"} onClick={() => refresh()}>
              <RefreshIcon />
            </Button>
          ) : null}
        </div>
      </Box>
    </td>
  </tr>
);

export default EmptyTablePlaceholder;
